<div class="stop-onboarding-container">
    <div class="stop-onboarding-illustration-wrapper">
        <img class="stop-onboarding-illustration-img"
            src="assets/images/illustrations--SomthingWentWrong.svg" alt="Manage Bookings" width="180"
            height="134">
        <div class="stop-onboarding-description-wrapper">
            <!-- <h3 class="title">{{ heading }}</h3> -->
            <h3 class="title">Already Registered Email Address</h3>
            <div class="content text-center">
                <!-- <p>{{ content }}
                    <span class="email" *ngIf="IsShowEmail">{{email}}</span>
                    {{ content }}
                </p> -->
                <p>Another account already exists with this email. Please contact your admin at
                    <span class="email">{{fetchMatchedEmail}}</span> to receive a new invite to complete your profile on Saudia Business.
                </p>
            </div>
            @if (IsShow) {
            <button mat-button class="button--primary-small m-top-8x" [routerLink]="navigateTo">
                Click to regenerate link
                <mat-icon fontSet="material-symbols-outlined"> arrow_forward </mat-icon>
            </button>
            }
        </div>
    </div>
</div>